<template>
  <div class="wai">
    <div class="headWrap">

      <div :class="['card', menuNeedOpacity?'needOpacity':'']">
        <div :class="size" class="input-search">
          <div class="input-container">
            <input v-bind="$attrs"
                   ref="input"
                   :value="value"
                   @change="(e)=>$emit('change',e.target.value)"
                   @keypress.enter="search"  type="text" placeholder="">
            <img class="prefix-icon"  @mouseover="showSearch()"  src="@/assets/images/search.png"  />

          </div>

        </div>
      </div>
    </div>
<!--    <span @click="search" class="input-search-button">搜索</span>-->
  </div>
</template>
<script>
export default {
  name: "input-search",
  model: {
    event: "change"
  },
  props: {
    value: String,
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    }
  },
  methods: {
    search() {
      this.$emit("search", this.$refs.input.value);
    }
  }
};
</script>

<style lang="less" scoped>
.wai {
  .headWrap {
    margin-top: 160px;
    position: fixed;
    display: flex;
    width: 600px;
    justify-content: center;
    z-index: 9;
    .card {
      //margin-right: -50px;
      margin-top: -385px;
      display: flex;
      justify-content: center;
      .input-search {
        overflow: hidden;
        ::-webkit-input-placeholder {
          color: @secondary-text-color;
        }
        /* 创建一个容器，用于放置输入框和毛玻璃背景 */
        .input-container {
          position: relative;
          display: inline-block;
          text-align: center;
        }

        /* 输入框样式 */
        .input-container input {
          display: flex;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(20px) /* 背景模糊 */ saturate(180%);
          -webkit-backdrop-filter: blur(10px) saturate(180%);
          width: 560px;
          height: 60px;
          position: relative;
          border-radius: 30px;
          border: none;
          outline: none;

        }

        /* 毛玻璃背景层 */
        .input-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 30px;
          filter: blur(10px); /* 模糊效果，数值可以根据需要调整 */
          //opacity: 0.5; /* 背景模糊层的透明度 */
          z-index: -1; /* 确保此层在输入框下方 */
        }
        &.small {
          height: 40px;
          font-size: 14px;
        }

        &.large {
          height: 60px;
          font-size: 20px;
        }
        .prefix-icon {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          right: -2px;
          height: 40px;
          display: grid;
          align-items: center; /* 垂直居中 */
          justify-items: center; /* 如果是单个项，水平居中 */
        }
        input {
          font-size: inherit;
          height: 100%;
          width: 100%;
          line-height: 100%;
          border: none;
          padding: 10px;
          padding-left: 2em;
        }
        &-button {
          padding: 9px;

          color: #fff;
          text-align: center;
          position: absolute;
          right: 0;

          top: 0;
          width: 100px;
          height: 100%;
          background: @main-color;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            // background: rgba(255, 255, 255, 0.5);
            &::before {
              transition: all 0.3s;
              content: "";
              position: absolute;
              width: 100%;
              top: -1px;
              bottom: -1px;
              background: rgba(255, 255, 255, 0.4);
            }
          }
        }
      }
    }

    .card h1 {
      color: #fff;
      text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .card p {
      color: #ddd;
    }
    .menu {
      margin-top: -100px;
      background-color: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(20px) /* 背景模糊 */ saturate(180%);
      -webkit-backdrop-filter: blur(10px) saturate(180%);
      border-radius: 10px;
      padding: 30px;
      max-width: 400px;
      text-align: center;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      //width: 100%;
      //height: 80px;
      //box-shadow: 0 0 75px 0 rgba(0,0,0,0.1);
      //background-color: rgba(0,0,0,0.1);
      //opacity: 1.9;
      .menuCenter {
        //height: 80px;
        //width: 1200px;
        /* 设置一个半透明的背景色，可选 */
        background-color: rgba(255, 255, 255, 0.1);

        /* 应用模糊效果 */
        backdrop-filter: blur(10px);



      }
    }
    .menu.needOpacity {
      opacity: 0.8;
    }
  }
  .headBlank {
    //height: 110px;
    //width: 100%;
  }
}
/* 设置激活状态下的 router-link 链接颜色 */
/* 设置默认的 router-link 链接颜色 */
.router-link {
  color: #333; /* 未激活时的颜色，例如深灰色 */
  text-decoration: none; /* 移除默认的下划线 */
}

/* 设置激活状态下的 router-link 链接颜色 */
.router-link-active {
  color: #333; /* 激活时的颜色，例如橙色 */
  text-decoration: none; /* 可选：保持无下划线，或根据需要调整 */
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">-->
<!--  @import './pageTop.scss'-->
<!--</style>-->
